import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { UserDetailsComponent } from './user-details.component';
import { SharedModule } from 'app/modules/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { TableModule } from '../table/table.module';
import { UsageModule } from './usage/usage.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TeamsListDialogComponent } from './teams-list-dialog/teams-list-dialog.component';
import { ConfirmDialogModule } from '../confirm-dialog/confirm-dialog.module';
import { DateSelectorModule } from '../date-selector/date-selector.module';
import { PracticeSetAnalyticsModule } from '../practice-set-analytics/practice-set-analytics.module';
import { AdavanceVectoringUsersComponent } from './adavance-vectoring-users/adavance-vectoring-users.component';
import { MatSortModule } from '@angular/material/sort';
import { AdvanceVectoringUsersGraphComponent } from './advance-vectoring-users-graph/advance-vectoring-users-graph.component';
import { BasicVectoringUsersComponent } from './basic-vectoring-users/basic-vectoring-users.component';
import { BasicVectoringUsersGraphComponent } from './basic-vectoring-users-graph/basic-vectoring-users-graph.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdvanceVectoringUsersMissionComponent } from './advance-vectoring-users-mission/advance-vectoring-users-mission.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BasicVectoringUsersMissionComponent } from './basic-vectoring-users-mission/basic-vectoring-users-mission.component';
import {BasicVectoringLevelwiseComponent}  from'./basic-vectoring-levelwise/basic-vectoring-levelwise.component';
import { MembersTabStarsLessonsAnalticsComponent } from './members-tab-stars-lessons-analtics/members-tab-stars-lessons-analtics.component';
import { MembersTabStarsUserDetailsAnalticsComponent } from './members-tab-stars-user-details-analtics/members-tab-stars-user-details-analtics.component';
import { MembersTabStarsLessonSessionCountAnalticsComponent } from './members-tab-stars-lesson-session-count-analtics/members-tab-stars-lesson-session-count-analtics.component'

const routes: Routes = [
  { path: 'details/:name', component: UserDetailsComponent },
  { path: 'details/advance/:userName/:missionName', component: AdvanceVectoringUsersMissionComponent },
  { path: 'details/basic/:userName/:missionName', component: BasicVectoringUsersMissionComponent },
  { path: 'details/basic/levelwise/:userName/:missionName', component: BasicVectoringLevelwiseComponent }
];

@NgModule({
  declarations: [UserDetailsComponent, TeamsListDialogComponent, AdavanceVectoringUsersComponent, AdvanceVectoringUsersGraphComponent, BasicVectoringUsersComponent, BasicVectoringUsersGraphComponent, AdvanceVectoringUsersMissionComponent,BasicVectoringUsersMissionComponent, BasicVectoringLevelwiseComponent, MembersTabStarsLessonsAnalticsComponent, MembersTabStarsUserDetailsAnalticsComponent, MembersTabStarsLessonSessionCountAnalticsComponent],
  imports: [
    MatSlideToggleModule,
    SharedModule,
    RouterModule.forChild(routes),
    MatCardModule,
    MatDividerModule,
    TableModule,
    UsageModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    FormsModule,
    MatSnackBarModule,
    ConfirmDialogModule,
    DateSelectorModule,
    PracticeSetAnalyticsModule,
    MatSortModule,
    MatTooltipModule
  ],
  exports: [UserDetailsComponent,TeamsListDialogComponent],
  providers: [
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 3000}}
  ]
})
export class UserDetailsModule { }
